import ROUTES from '../routes';
import InternalTransactions from '../hoc/internal/internal';
import InternalTransaction from '../hoc/internal/transaction';
import ExpandedGeneralLedgerTransaction from '../hoc/transactions/expanded-general-ledger-panel';

const InternalRoutes = {
  path: ROUTES.INTERNAL_TRANSACTION,
  element: <InternalTransactions />,
  children: [
    {
      path: ROUTES.INTERNAL_TRANSACTION_CREATE,
      element: <InternalTransaction />,
    },
    {
      path: ROUTES.INTERNAL_TRANSACTION_READ,
      element: <InternalTransaction />,
    },
    {
      path: ROUTES.INTERNAL_TRANSACTION_GL,
      element: (
        <ExpandedGeneralLedgerTransaction
          backLink={ROUTES.INTERNAL_TRANSACTION}
        />
      ),
    },
  ],
};

export default InternalRoutes;
